import React from 'react';
import styled from 'styled-components';    
import Card from 'common/Card';

export const Container = styled(Card)`
  // background-color: ${({ theme }) => theme.palette.background.paper};
  height: 100%;
  overflow: auto;
`;
